import {
  useRoutes,
  useLocation,
  useNavigate,
  matchRoutes,
} from "react-router-dom";
import { useEffect } from "react";
import routes from "./router";
import { WeirwoodErrorBoundary } from "../pages/weirwoodErrorBoundary";
import usePageExposure from '@hooks/usePageExposure';
import { usePageLeave } from '@hooks/usePageLeave';
import { useDevice } from "../hooks/useDevice";
import {ubcInit} from '@utils/ubcLogger/send';
import { initParis } from "@utils/initParis";

function App() {
  const element = useRoutes(routes);
  const location = useLocation();
  const navigate = useNavigate();
  const { isMobile, isReady } = useDevice();

  useEffect(() => {
    if (!isReady) return;
    const { pathname, search, hash } = location;
    // 针对 /workbench/web 和 /workbench/mobile 进行互转
    let targetPath = "";
    if (pathname.startsWith("/workbench/web") && isMobile) {
      targetPath = pathname.replace("/workbench/web", "/workbench/mobile");
    } else if (pathname.startsWith("/workbench/mobile") && !isMobile) {
      targetPath = pathname.replace("/workbench/mobile", "/workbench/web");
    }

    if (targetPath) {
      // 检查目标路径是否存在于路由配置中
      const matches = matchRoutes(routes, targetPath);
      // 如果匹配到了路由，且不是 404 页面（path 为 '*'），则进行跳转
      if (matches && matches.length > 0) {
        const lastMatch = matches[matches.length - 1];
        if (lastMatch.route.path !== "*") {
          navigate(targetPath + search + hash, { replace: true });
        }
      }
    }
  }, [location, isMobile, isReady, navigate]);

    useEffect(() => {
        ubcInit('mzDoctor', 14033, {
            appname: 'baidujiankangapp',
            testMode: process.env.NODE_ENV !== 'production',
            product: 'fe-doctor-workbench'
        });
        initParis();
    }, []);

    // 时长埋点: 屏蔽移动端
    usePageLeave({ enabled: !isMobile });

    usePageExposure({rootMargin: '0px 0px 0px 0px', threshold: 0}, 2000);

  return (
    <WeirwoodErrorBoundary>
      <div>{element}</div>
    </WeirwoodErrorBoundary>
  );
}

export default App;
